import { Component, HostListener, Input, OnInit } from '@angular/core';
import { timeConvert } from '@app-helpers/functions';
import * as d3 from 'd3';
@Component({
  selector: 'app-stackedbarchart',
  templateUrl: './stackedbarchart.component.html',
  styleUrls: ['./stackedbarchart.component.css']
})
export class StackedbarchartComponent implements OnInit {
  @HostListener('window:resize', ['$event'])
  public examtype = 'neet'
  @Input('testReport') testdata: any = {}
  @Input('examinfo') examinfo: any = {}
  @Input('examRanges') public examRanges:any ={};
  avgTimeperQuestion = [];
  colorData: any;
  linearDashScale:any
  onresize(event) {
    this.fixbarchart()
  }
  dynamicCntainer = 'demo2';
  alphabet: any = []
  colorPercentageGradient: any = [
    {
      "color": "#EBC624",
      "percentage": 0,
      "range": "Beginner"
    },
    {
      "color": "#CBBE48",
      "percentage": 9.09,
      "range": ""
    },
    {
      "color": "#29A3D8",
      "percentage": 18.18,
      "range": ""
    },
    {
      "color": "#07ABF2",
      "percentage": 27.27,
      "range": "Progress"
    },
    {
      "color": "#29A3D8",
      "percentage": 36.36,
      "range": ""
    },
    {
      "color": "#74BEBA",
      "percentage": 45.45,
      "range": ""
    },
    {
      "color": "#6ACD86",
      "percentage": 54.54,
      "range": ""
    },
    {
      "color": "#4BD85F",
      "percentage": 63.63,
      "range": "Good"
    },
    {
      "color": "#6DC665",
      "percentage": 72.72,
      "range": ""
    },
    {
      "color": "#DA914E",
      "percentage": 81.81,
      "range": ""
    },
    {
      "color": "#E05252",
      "percentage": 90.90,
      "range": "Star"
    },
    {
      "color": "#E73030",
      "percentage": 100,
      "range": "empty"
    }
  ]

  chartUtility: any = {
    width: 0,
    height: 0,
    avaibleHeight: 0,
    avaibleWidth: 0,
    yScale: 0,
    xScale: 0,
    one_percent_height: 0,
    one_percent_width: 0,
    margin: {}
  }
  //for below  i divided total into percentages
  // For JEE Main: Beginner band starts from the lowest score of this paper or 0 whichever is lowest upto < 150 marks; Progress is ≥ 150 marks and < 180 marks; Good is ≥ 180 marks and < 220 marks; Star is ≥ 220 marks ≤ 300 marks.
  // 
  // For NEET: Beginner band starts from the lowest score of this paper or x whichever is lowest upto < 550 marks; Progress is ≥ 550 marks and < 600 marks; Good is ≥ 600 marks and < 650 marks; Star is ≥ 650 marks ≤ 720 marks.
  public jeeRange: any = []
  public timeRange: any = []
  public percentageRange: any = [];
  public rankRange:any = [];
   
  accuracyRange = []
 
  constructor() { }


  ngOnInit(): void {
  }
  ngAfterViewInit(){
    document.getElementById('demo2').addEventListener("scroll",(e:any) => {
      d3.select('#yellow-box').attr("x",e?.srcElement?.scrollLeft)   
      d3.select('#rangelinetext').selectAll('text').attr("x",1+this.chartUtility.margin.left * 0.10+e?.srcElement?.scrollLeft)          
    })
    document.getElementById('demo2').addEventListener("drag",(e:any) => {      
      d3.select('#yellow-box').attr("x",e?.srcElement?.scrollLeft)   
      d3.select('#rangelinetext').selectAll('text').attr("x",1+this.chartUtility.margin.left * 0.10+e?.srcElement?.scrollLeft)    
      })
  }
 
  ngOnChanges() {
  
    this.fixbarchart();
  }
  fixbarchart() {
    this.updateData()
    if (!this.testdata?.rank) {
      let findIndex = this.alphabet.findIndex(v => v.letter == 'Rank')
      this.alphabet.splice(findIndex, 1)
    }
    if (!document.getElementById(this.dynamicCntainer)?.offsetWidth) {
      setTimeout(() => {
        this.fixbarchart()
      }, 1000);
    } else {
      // container size
      var width = document.getElementById(this.dynamicCntainer).offsetWidth;
      var height = document.getElementById(this.dynamicCntainer).offsetHeight || 200;
      var xScaleRange = this.alphabet.length *  (this.MobileScreen() ? 75 :120 ) < width ? width : this.alphabet.length * (this.MobileScreen ? 75 :120 );
      let one_percent_width = xScaleRange * 0.01;
      let one_percent_height = height * 0.01;
      let margin = {
        top: one_percent_height * 10,
        bottom: one_percent_height * (this.MobileScreen() ? 20 :10),
        right: one_percent_width * 10,
        left: one_percent_width * 10,
      }
      var available_width = width - margin.right - margin.left;
      var available_height = height - margin.top - margin.bottom;
      var name = 'dashboard';
      this.chartUtility.width = width;
      this.chartUtility.height = height;
      this.chartUtility.avaibleHeight = available_height;
      this.chartUtility.avaibleWidth = available_width;
      this.chartUtility.margin = margin
      // x scale
      let simpaadiing = this.MobileScreen() ? 0.80 : 0.88
      var xScale = d3.scaleBand()
        .rangeRound([0, xScaleRange - margin.left - margin.right]).paddingInner(simpaadiing)
      // set x and y scales
      xScale.domain(this.alphabet.map(function (d: any) {
        return d?.letter;
      }));

      // x axis
      var xAxis = d3.axisBottom(xScale)
        .scale(xScale)
      var yScale = d3.scaleLinear()
        .domain([0, Math.max(...this.alphabet.map(d => d?.frequency))])
        .range([available_height, 0]);

      this.chartUtility.yScale = yScale;
      this.chartUtility.xScale = xScale;
      this.chartUtility.one_percent_height = one_percent_height;
      this.chartUtility.one_percent_width = one_percent_width;
      // create svg container
      let id = `#${this.dynamicCntainer}`;
      d3.select(id).select('svg').remove()
      var svg = d3.select(id)
        .append('svg')
        .attr("id","mysvg")
        .style("overflow-x", "scroll")
        .style("display", "inline-block")
        .attr('class', 'd3-setup-barchart')
        .attr('width', xScaleRange+(this.MobileScreen() ? 30:0))
        .attr('height', height)
        .style("background-color", "rgb(255, 255, 255)")

      var grad = svg.append('defs')
        .append('linearGradient')
        .attr('id', 'grad')
        .attr('x1', '0%')
        .attr('x2', '0%')
        .attr('y1', '0%')
        .attr('y2', '100%');

      grad.selectAll('stop')
        .data(this.colorPercentageGradient)
        .enter()
        .append('stop')
        .style('stop-color', (d: any) => d.color)
        .attr('offset', (d: any) => d.percentage + '%');


      // create bars
      let bar_xposition = 0;
      var bargroup = svg.append('g')
      var bars = bargroup.selectAll('.bar')
        .data(this.alphabet)
        .enter()
        .append('g')
        
      bars.append('rect')
        .attr('class', function (d, i) {
          return 'bar';
        })
        .attr('x', (d: any) => xScale(d?.letter) + (xScale.bandwidth()) / 2)
        .attr('width', function () {
          return Math.min(xScale.bandwidth(), 250);
        })
        .attr('y', function (d: any) {
          return yScale(d?.frequency);
        })
        .attr('height', function (d: any) {
          return available_height - yScale(d.frequency);
        })
        .attr('rx', this.MobileScreen()?0.5:10)
        .attr('fill', '#ffffff')
        
        bars.append('rect')
        .attr('class', function (d, i) {
          return 'bar';
        })
        .attr('x', (d: any) => xScale(d?.letter) + (xScale.bandwidth()) / 2)
        .attr('width', function () {
          return Math.min(xScale.bandwidth(), 250);
        })
        .attr('y', function (d: any) {
          return yScale(d?.frequency);
        })
        .attr('height', function (d: any) {
          return available_height - yScale(d.frequency);
        })
        .attr('rx', this.MobileScreen()?7:18)
        
        .style('opacity', '1')
        .attr('fill', 'url(#grad)')
        .style('opacity', '0.8')
        .attr('fill', 'url(#grad)')

        .on('click', function (d, i) {
        })

      bargroup.attr('transform', `translate(${margin.left+30},${margin.top})`).attr("id","bargroup")

      bargroup.selectAll('.bar')
        .data(this.alphabet)
        .enter()
        .append('g')
      bars.append("svg:image")
        .attr("xlink:href", "assets/img/equaliserpointer.svg")
        .attr('x', (d: any) => 1+xScale(d?.letter) + (xScale.bandwidth()) / 2)
        .attr('width', (d) => Math.min(xScale.bandwidth(), 100) -4 )
        .attr('y', (d: any) => this.chartUtility.avaibleHeight - this.chartUtility.margin.bottom)
        .transition()
        .duration(3000)
        .attr('y', (d: any) => this.getDifferentYscale(d))

      // draw x axis
      let axisNames_Y = (this.MobileScreen() ? 0:4 );
      var xaxis = svg.append('g')
        .attr('id', name + '-x-axis')
        .attr('class', 'equaliser-x-axis')
        .attr('transform', `translate(${margin.left +30+ (Math.min(xScale.bandwidth()) / 2)},${(axisNames_Y+height - margin.bottom)})`)
        .call(xAxis)
        xaxis.selectAll('text')
        .style("font-size", this.MobileScreen() ? '8px':"16px")
        .style("font-weight", "500")
        .style("line-height", this.MobileScreen() ? '9.75px':"19.5px")
        .style("color", "#324452")
        .style("font-family"," 'Montserrat',sans-serif")
      xaxis.selectAll('path')
        .attr('d', '0')
      xaxis.selectAll('line')
        .attr('stroke', 'none')
      if (this.MobileScreen()) {
        var yposition_label = []
        xaxis.selectAll('text').each(function (d, i) {
          yposition_label.push(d3.select(this).attr("y"))
        })
        xaxis.selectAll('.tick')
          .append("text")
          .text((v, i) => this.alphabet?.[i]?.mobilescore)
          .style("fill", "#324452")
          .style("font-weight", "600")
          .style("font-family"," 'Montserrat',sans-serif")
          .attr("y", (v, i) => {
            return +yposition_label[i] + 20
          })
      }
      svg
        .select('.horizontal')
        .selectAll('.tick')
        .filter(function (d: any) {
          return d === 0 || d % 1 !== 0;
        }).remove();
    }
    this.generateRangeLine(svg);

    this.generateRangeName(svg)


  }
  generateRangeLine(svg) {
    let colorData = this.colorPercentageGradient.filter((v, i) => v.range)
    let rangeBottom = this.chartUtility.height - this.chartUtility.margin.bottom
    var linearDashScale = d3.scaleLinear().domain([0, Math.max(...colorData.map(v => v.percentage))]).range([rangeBottom, this.chartUtility.margin.top])
   if(this.MobileScreen()){
 svg.append('g')
    .append('rect')
    .attr("height",this.chartUtility.height)
    .attr("width",this.chartUtility.one_percent_width*14)
    .attr("fill","#FEF9EF")
    .style("border","0.63275px solid #E7E8F1")
    .style("box-shadow"," 0px 2.531px 18.9825px rgba(0, 0, 0, 0.051)")
    .attr('x', (d: any) =>0)
    .attr('y', (d: any) =>0)
    .attr("id","yellow-box")
   }
   
  
    var rangeDashLines = svg.append('g')
      .selectAll('line')
      .data(colorData)
      .enter()
      .append("line")
      .attr("x1", v => this.chartUtility.one_percent_width)
      .attr("x2", v =>( this.chartUtility.one_percent_width * 100)+(this.MobileScreen() ? 30:0))
      .attr("y1", v => {
        return (linearDashScale(v.percentage))
      })
      .attr("y2", v => {
        return (linearDashScale(v.percentage))
      })
      .style("stroke", "#A5AAAF")
      .style("stroke-dasharray", ("3, 7"))
      this.colorData = colorData;
      this.linearDashScale = linearDashScale
  }
  generateRangeName(svg){
    var rangeTextname = svg.append('g')
    .attr("id","rangelinetext")
    .selectAll('text')
      .data(this.colorData)
      .enter()
      .append("text")
      .text(v => v.range !== 'empty' ? v.range : '')
      .attr("x", v => 1+this.chartUtility.margin.left * 0.20)
      .attr("y", v => {
        return (this.linearDashScale(v.percentage) - (this.MobileScreen()? 5:5))
      })
      .attr("fill", "#A5AAAF")
    
      .attr("font-size",this.MobileScreen() ? '9px':'18px')
      .attr("line-height",this.MobileScreen() ? '9.75px':'21.94px')
      .attr("positon",'sticky')
      
  }
  getDifferentYscale(element) {
    let mappingObject = {
      'Score': 'jeeRange',
      'Time': 'timeRange',
      'Percentage': 'percentageRange',
      'Accuracy': 'accuracyRange',
      'Rank':'rankRange'
    }
    if (['Score', 'Time', 'Percentage', 'Accuracy', 'Time/ Question', 'Rank'].indexOf(element.letter) !== -1) {
      let findRange = this[mappingObject[element.letter]]?.find(v => (element.score < v.maxscale || element.score == v.maxscale))
      if (element.letter == 'Time/ Question') {
        findRange = this.avgTimeperQuestion.find(v => ((element.score < v.maxscale || element.score == v.maxscale) && (element.score > v.minscale || element.score == v.minscale)))
      }
      // var toprange = [findRange?.minscale || 0, findRange?.maxscale || element?.score]
      let score = (element.score) > element?.maxscale ? element.maxscale : (element?.score < 0 ?  0 :element?.score);
      let minramnge = this.chartUtility.yScale(findRange?.maxcolorRange || element?.score);
      let maxRange = this.chartUtility.yScale(findRange?.mincolorrange || 0);
      var linearDashScale = d3.scaleLinear().domain([findRange?.minscale || 0, findRange?.maxscale || element?.score]).range([maxRange, minramnge])
      let linearv = linearDashScale(score) 
      const finalLine = linearv - (this.MobileScreen()? 0:9.5) > 0 ? ((linearv - maxRange)<(this.MobileScreen()? ((Math.abs(linearv - maxRange) < 10?10:4)):((Math.abs(linearv - maxRange) < 20?20:0)))?linearv-(this.MobileScreen()? ((Math.abs(linearv - maxRange) < 10?10:4)):(Math.abs(linearv - maxRange) < 20?20:0)):linearv - (this.MobileScreen()? 0:9.5))  : 0
      return finalLine < 0 ? 0.5 : finalLine
      // return  finalLine

    }
  }
  updateData() {
  let rankscale =  d3.scaleLinear().domain( [this.testdata?.lowestRank,this.testdata?.highestRank]).range([100,0])
  let spentaverageTimePerQuestion :any=   this.testdata?.spentaverageTimePerQuestion
    this.alphabet = [
      {
        "frequency": 100,
        "letter": 'Score',
        "minscale": 0,
        "maxscale": 100,//this.testdata?.outOfScore,
        "score": 100*(this.testdata?.totalScore/this.testdata?.outOfScore),
        "mobilescore": this.testdata?.totalScore,
      },
      {
        "frequency": 100,
        "letter": 'Rank',
        "minscale": rankscale(this.testdata?.highestRank),
        "maxscale": rankscale(this.testdata?.lowestRank),
        "score":rankscale(this.testdata?.rank||0),  //Math.ceil((this.testdata?.rank||0)/this.testdata?.lowestRank)*100,//this.testdata?.rank,
        "mobilescore": this.testdata?.rank,
      },
      {
        "frequency": 100,
        "letter": 'Percentage',
        "minscale": 0,
        "maxscale": 100,
        "score": this.testdata?.percentage || 0,
        "mobilescore": Number.parseFloat(this.testdata?.percentage||0).toFixed(0)+'%',
      },
      {
        "frequency": 100,
        "letter": 'Time',
        "minscale": 0,
        "maxscale":100, //this.testdata?.examDuration || this.examinfo?.duration || 0,
        "score":100*(( this.testdata?.totalVisitedTime / 60)/(this.testdata?.examDuration || this.examinfo?.duration)),
        "mobilescore": timeConvert( this.testdata?.totalVisitedTime )
      },
      
      {
        "frequency": 100,
        "letter": 'Accuracy',
        "minscale": 0,
        "maxscale": 100,
        "score": this.testdata?.accuracy || 0,
        "mobilescore": Number.parseFloat(this.testdata?.accuracy || 0).toFixed(0)+'%',
      },
      {
        "frequency": 100,
        "letter": 'Time/ Question',
        "minscale": 0,
        "maxscale": (this.testdata?.examDuration || this.examinfo?.duration)*60,
        "score":  (this.testdata?.spentaverageTimePerQuestion), //this.testdata?.spentaverageTimePerQuestion /60||0 ,
        "mobilescore": spentaverageTimePerQuestion > 60 ?`${ Math.floor(spentaverageTimePerQuestion/60||0).toFixed(0)}m ${spentaverageTimePerQuestion%60}s` :(`0m ${(spentaverageTimePerQuestion||0).toFixed(0)}s`)//timeConvert( this.testdata?.spentaverageTimePerQuestion||0)
      },

    ]
    this.jeeRange = this.setDesiredRange('score')     
    //   Time: This is the total time taken by the student to submit the paper
    // For JEE Main: Beginner band starts from the 0 to 2 hrs. Progress is ≥ 2hrs and < 2 hrs 45 mins; Good is ≥ 2 hrs 45 mins and < 2 hrs 55 mins; Star is ≥ 2 hrs 55 mins.
    // For NEET: Beginner band starts from the 0 to 3 hrs. Progress is ≥ 3 hrs and < 3 hrs 10 mins; Good is ≥ 3 hrs 10 mins and < 3 hrs 15 mins; Star is ≥ 3 hrs 15 mins.
    this.timeRange = this.setDesiredRange('time')
    //   For JEE Main: Beginner band starts from more than 4 minutes to max time of exam; Progress is > 3 mins and ≤ 4 mins; Good is > 2 mins 24s and ≤ 3 mins; Star is < 2 mins 24s.
    // For NEET: Beginner band starts from more than 1 minute 30s to max time of exam; Progress is > 1 min 15s and ≤ 1 min 30s; Good is > 1 mins 5s and ≤ 1 min 15s; Star is < 1 mins 5s.
    this.avgTimeperQuestion = this.setDesiredRange('timeperquestion')
    this.percentageRange = this.setDesiredRange('percentage')
    this.accuracyRange =this.setDesiredRange('accuary')
    this.rankRange= this.setDesiredRange('rank')
  }
  setDesiredRange(key){
    var percenteageArray = [{
      minscale:(key=='rank') ?this.examRanges?.[key]?.Star?.min :  this.examRanges?.[key]?.Beginner?.min,  
      maxscale: (key=='rank') ? this.examRanges?.[key]?.Star?.max: (key == 'timeperquestion'? ( ( this.testdata?.examDuration*60 || this.examinfo?.duration*60)):this.examRanges?.[key]?.Beginner?.max),//beginner
      mincolorrange: 0,
      maxcolorRange: 27.27
    },
    {
      minscale: (key=='rank') ?this.examRanges?.[key]?.Good?.min : this.examRanges?.[key]?.Progress?.min,
      maxscale:(key=='rank') ?this.examRanges?.[key]?.Good?.max : this.examRanges?.[key]?.Progress?.max,//Progress
      mincolorrange: 27.27,
      maxcolorRange: 63.63
    },
    {
      minscale: (key=='rank') ? this.examRanges?.[key]?.Progress?.min:this.examRanges?.[key]?.Good?.min,
      maxscale:(key=='rank') ? this.examRanges?.[key]?.Progress?.max: this.examRanges?.[key]?.Good?.max,//Good0.73  0.90
      mincolorrange: 63.63,
      maxcolorRange: 90.90
    },
    {
      minscale: (key=='rank') ? this.examRanges?.[key]?.Beginner?.min:this.examRanges?.[key]?.Star?.min,
      maxscale:key=='rank' ? this.examRanges?.[key]?.Beginner?.max||100:( key == 'time' )? ((this.testdata?.examDuration || this.examinfo?.duration)*60):this.examRanges?.[key]?.Star?.max ,//Star1
      mincolorrange: 90.90,
      maxcolorRange: 100
    }];
    return percenteageArray
  }
  MobileScreen(){
    return (window.innerWidth > 319 && window.innerWidth <  769)
  }
}
//  this.examRanges?.[key]?.Star?.max  this.examRanges?.[key]?.Star?.max :